<template>
  <v-container v-if="hasAudioSettings">
    <v-row>
      <v-col cols="12"></v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="no-padding align-vertical">
        <div>Volume:</div>
      </v-col>
      <v-col cols="5">
        <v-slider
          class="volume-slider"
          :value="volume"
          thumb-label="always"
          step="10"
          min="0"
          max="100"
          @change="parseNewVal($event, 'volume', 'Audio Settings / Volume')"
        ></v-slider>
      </v-col>
    </v-row>

    <FormRow
      label="DMS Audio Warnings"
      :input-payload="dmsTone"
      :dropdown="true"
      :options="toneTypeMap"
      @parseNewVAl="
        parseNewVal($event, 'dmsTone', 'Audio Settings / DMS Sound Set')
      "
    />

    <FormRow
      v-if="supportsAdas"
      label="ADAS Audio Warnings"
      :input-payload="adasTone"
      :dropdown="true"
      :options="toneTypeMap"
      @parseNewVAl="
        parseNewVal($event, 'adasTone', 'Audio Settings / DMS Sound Set')
      "
    />
  </v-container>
</template>

<script>
import FormRow from "../components/FormRow.vue";

import { deviceConfigMixin } from "@/mixins/deviceConfigMixin.js";

// import { Logger } from "aws-amplify";
// const logger = new Logger("device config / audio settings");

export default {
  name: "Audio",
  components: {
    FormRow,
  },
  mixins: [deviceConfigMixin],
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      volume: "",
      dmsTone: "",
      adasTone: "",
      toneTypeMap: [
        {
          xml: "tone",
          label: "Tone",
        },
        {
          xml: "voice",
          label: "Voice",
        },
        {
          xml: "toneAndVoice",
          label: "Tone & Voice",
        },
      ],
    };
  },
  computed: {
    selectedDmsTone() {
      return this.config.device_config.audio[0].dms[0].soundSet[0]
        .selectedOption[0];
    },
    selectedAdasTone() {
      return this.supportsAdas
        ? this.config.device_config.audio[0].adas[0].soundSet[0]
            .selectedOption[0]
        : false;
    },
    selectedVolume() {
      return this.config.device_config.audio[0].playbackVol[0];
    },
    hasAudioSettings() {
      return this.config && this.config.device_config.audio ? true : false;
    },
    supportsAdas() {
      return Object.prototype.hasOwnProperty.call(
        this.config.device_config.cv[0],
        "adas"
      ) && this.config.device_config.cv[0].adas[0].selectedProvider[0] == "icar"
        ? true
        : false;
    },
  },
  mounted() {
    this.mapFormProps();
  },
  methods: {
    mapFormProps() {
      if (!this.hasAudioSettings) return;

      this.volume = this.selectedVolume;
      this.dmsTone = this.selectedDmsTone;
      if (this.supportsAdas) {
        this.adasTone = this.selectedAdasTone;
      }
    },
    configPropMapper(key) {
      let map = {
        dmsTone: "device_config.audio[0].dms[0].soundSet[0].selectedOption[0]",
        adasTone:
          "device_config.audio[0].adas[0].soundSet[0].selectedOption[0]",
        volume: "device_config.audio[0].playbackVol[0]",
      };

      return map[key];
    },
    parseNewVal(val, id, label) {
      let payload = {
        newValue: this.returnMappedVal(val, [this.toneTypeMap]),
        key: this.configPropMapper(id),
        label: label,
      };
      this.$emit("settingsUpdated", payload, this.toneTypeMap);
    },
  },
};
</script>

<style lang="scss">
.v-slider--horizontal {
  margin-left: 0 !important;
}
.volume-slider {
  width: 235px !important;
}
</style>
